import BreadCrumb from "@elements/BreadCrumb/BreadCrumb";
import Heading from "@elements/Typography/Heading";
import { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

import getPageDetails from "../helper/getPageDetails";

export type MainBlockProps = Readonly<{
  children: ReactNode;
  className?: string;
  testId?: string;
  showTitle?: boolean;
  showBreadcrumbs?: boolean;
  pageName?: string;
}>;

export default function MainBlock({
  children,
  className,
  pageName,
  testId = "main-block",
  showTitle = true,
  showBreadcrumbs = true,
}: MainBlockProps): ReactElement {
  const { label } = getPageDetails(pageName) || {};

  const breadcrumbItems = [{ label: "Home", url: "/" }, { label: label }];

  return (
    <div
      className={twMerge(
        "w-full lg:w-8/12 lg:border-r lg:border-pink-300 lg:pr-xs",
        className,
      )}
      data-testid={testId}
    >
      {showBreadcrumbs && pageName && <BreadCrumb items={breadcrumbItems} />}
      {showTitle && (
        <Heading className="text-3xl font-bold font-primary">{label}</Heading>
      )}
      {children}
    </div>
  );
}
